import { TmaisUserData } from "../types/tmaisUsers.type";
import TmaisUserGeneralData from "../tabs/users/components/showUser/GeneralData";

interface DefaultTabsProps {
  tmaisUser: TmaisUserData
}

export const defaultTabs = ({tmaisUser}: DefaultTabsProps) => {
  return [
    {
      label: 'Dados Gerais',
      value: '',
      body: <TmaisUserGeneralData tmaisUser={tmaisUser} />
    },
  ]
}
